import Image from "next/image";
import Button from "../components/common/Button";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState, useRef, useEffect } from "react";
import { usePopup } from "../context/context";
import { freeTrialSubsdata, isLoggedIn } from "../utilities/utils";
import { Transition } from "@headlessui/react";

const Links = [
  {
    text: "Home",
    link: "/",
  },
  // {
  //   text: "Rank Tracker",
  //   link: "/rank-tracker",
  // },
 
  {
    text: "SEO Tools",
    link: "#",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    sublinks: [
      {
        text: "Rank Tracker",
        link: "/rank-tracker",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        ),
        description: "Track your keyword rankings across search engines"
      },
      {
        text: "Keyword Research",
        link: "/keyword-research",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        ),
        description: "Discover high-value keywords for your business"
      },
      {
        text: "AI Analyze",
        link: "/ai-analyze",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        ),
        description: "Get AI-powered insights to improve your SEO"
      },
    ],
    
  },
  {
    text: "Free Tools",
    link: "#",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    sublinks: [
      {
        text: "Keyword Planner",
        link: "/free-keyword-planner",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        ),
        description: "Plan your content with keyword insights"
      },
      {
        text: "Rank Checker",
        link: "/free-rank-checker",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        ),
        description: "Check your website's ranking for specific keywords"
      },
      {
        text: "Youtube Tag Generator",
        link: "/youtube-tag-generator",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        description: "Generate effective tags for YouTube videos"
      },
      {
        text: "Word Counter",
        link: "/free-word-counter",
        icon: (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
          </svg>
        ),
        description: "Count words and characters in your content"
      },
    ],
  },
  {
    text: "Pricing",
    link: "/pricing",
  },
    // REMOVED/COMMENTED OUT CONTACT LINK
];

const Header = () => {
  const loggedIn = isLoggedIn();
  const [hoveredItem, setHoveredItem] = useState(null);
  const router = useRouter();
  const { isPopupOpen, togglePopup } = usePopup();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobileScrolling, setIsMobileScrolling] = useState(false);

  // Track menu navigation
  const trackMenuNavigation = (menuName, destination) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'menu_click', {
        'event_category': 'Navigation',
        'event_label': menuName,
        'destination': destination
      });
      console.log(`Tracked menu navigation: ${menuName} to ${destination}`);
    }
  };

  // Track login button click
  const trackLoginClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'login_click', {
        'event_category': 'User Action',
        'event_label': 'Header Login Button'
      });
      console.log('Tracked login button click');
    }
  };

  // Track free trial button click
  const trackFreeTrialClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'free_trial_click', {
        'event_category': 'Conversion',
        'event_label': 'Header Free Trial Button'
      });
      console.log('Tracked free trial button click');
    }
  };

  // Close dropdown menu when route changes
  useEffect(() => {
    setHoveredItem(null);
    const handleRouteChange = () => {
      setHoveredItem(null);
    };

    router.events.on('routeChangeStart', handleRouteChange);
    
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  // Handle iOS Safari bottom bar and mobile scrolling
  useEffect(() => {
    let scrollTimer;
    
    const handleScroll = () => {
      if (window.innerWidth <= 768) { // Only for mobile devices
        setIsMobileScrolling(true);
        
        // Auto-close mobile menu when scrolling on iOS
        if (menuOpen) {
          setMenuOpen(false);
        }
        
        // Reset scroll state after scrolling stops
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          setIsMobileScrolling(false);
        }, 150);
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimer);
    };
  }, [menuOpen]);

  const menuHandler = () => {
    setMenuOpen(!menuOpen);
  };

  const isActive = (link) => {
    return router.asPath === link;
  };
  
  const isAnySubLinkActive = (sublinks) => {
    return sublinks.some((sublink) => isActive(sublink.link));
  };

  const shouldShowMenu = !!!router.asPath.includes("payment-cancel") &&
    !!!router.asPath.includes("payment-success") &&
    !!!router.asPath.includes("sign-in") &&
    !!!router.asPath.includes("sign-up") &&
    !!!router.asPath.includes("forgot-password") &&
    !!!router.asPath.includes("forgot-email") &&
    !!!router.asPath.includes("send-email") &&
    !!!router.asPath.includes("set-password") &&
    !!!router.asPath.includes("confirm-password");

  return (
    <>
      <div className="py-5 block md:px-20 px-4 shadow-md shadow-[#049A55]/10 sticky top-0 right-0 z-40 bg-white">
        <div className="flex justify-between items-center">
          <div className="cursor-pointer">
            <Image
              onClick={() => {
                router.push("/");
                trackMenuNavigation('Logo', '/');
              }}
              src={"/images/PRIMARY-LOGO.png"}
              width={170}
              height={71}
              alt="serp logo"
            />
          </div>
          {shouldShowMenu ? (
            <div className="lg:flex hidden items-center gap-6">
              {Links.map((item, index) => (
                <div
                  key={index}
                  className="relative"
                  onMouseEnter={() => setHoveredItem(item.text)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  {item.sublinks ? (
                    <div 
                      className={`${
                        (item.sublinks && isAnySubLinkActive(item.sublinks)) ? "text-[#049A55] font-medium" : ""
                      } text-gray-800 font-medium text-base leading-normal flex items-center cursor-pointer hover:text-[#049A55] transition-colors duration-150`}
                      onClick={() => {
                        if (item.link !== "#") {
                          router.push(item.link);
                          trackMenuNavigation(item.text, item.link);
                        }
                      }}
                    >
                      {item?.text}
                      <div className="ms-1">{item.svg}</div>
                    </div>
                  ) : (
                    <Link href={item.link} passHref>
                      <div
                        className={`${
                          router.asPath === item.link ? "text-[#049A55] font-medium" : ""
                        } text-gray-800 font-medium text-base leading-normal flex items-center hover:text-[#049A55] transition-colors duration-150`}
                        onClick={() => trackMenuNavigation(item.text, item.link)}
                      >
                        {item?.text}
                      </div>
                    </Link>
                  )}
                  
                  {item.sublinks && (
                    <div 
                      className={`absolute top-full text-gray-800 left-0 bg-white border border-gray-100 w-[360px] shadow-lg rounded-lg overflow-hidden z-50 ${hoveredItem === item.text ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'} transition-all duration-200 mt-2`}
                      onMouseEnter={() => setHoveredItem(item.text)}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <div className="py-2">
                        {item.sublinks.map((sublink, subIndex) => (
                          <Link key={subIndex} href={sublink.link} passHref>
                            <div 
                              className="px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors duration-150 group border-b border-gray-100 last:border-b-0 relative"
                              onClick={() => {
                                setHoveredItem(null);
                                trackMenuNavigation(`${item.text} - ${sublink.text}`, sublink.link);
                              }}
                            >
                              {/* Green line that appears on hover */}
                              <div className="absolute left-0 top-0 w-1 bg-[#049A55] h-full opacity-0 group-hover:opacity-100 transition-opacity duration-150"></div>
                              
                              <div className="flex items-start">
                                <div className={`w-9 h-9 mt-0.5 bg-[#049A55]/10 text-[#049A55] rounded-md flex items-center justify-center flex-shrink-0`}>
                                  {sublink.icon}
                                </div>
                                <div className="mx-3 flex-1">
                                  <div className="flex items-center">
                                    <p className={`font-medium text-base ${isActive(sublink.link) ? 'text-[#049A55]' : 'text-gray-800'} group-hover:text-[#049A55] transition-colors duration-150`}>
                                      {sublink.text}
                                    </p>
                                  </div>
                                  <p className="text-sm text-gray-500 mt-1 line-clamp-2 max-w-[230px]">
                                    {sublink.description}
                                  </p>
                                </div>
                                <div className="text-gray-300 group-hover:text-[#049A55] transition-colors duration-150 mt-0.5">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M9 18l6-6-6-6"/>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : null}
          
          {shouldShowMenu ? (
            <div id="popup" className="lg:flex hidden items-center gap-3">
              {!loggedIn && (
                <Link href={"/sign-in"}>
                  <Button 
                    text={"Log in"} 
                    customClass={"text-base font-medium text-gray-700 hover:text-[#049A55] px-4 py-2 hover:bg-gray-100 rounded-md transition-colors"}
                    onClick={trackLoginClick}
                  />
                </Link>
              )}
              {/* <Link href={"/dashboard"}>
                <Button text={"Dashboard"} customClass={"text-base"} />
              </Link> */}
              {loggedIn && (
                <Button
                  onClick={() => {
                    router.push("/dashboard");
                    trackMenuNavigation('Dashboard Button', '/dashboard');
                  }}
                  text={"Dashboard"}
                  customClass={
                    "text-base font-medium bg-[#002E25] text-white px-5 py-2 rounded-md hover:bg-[#004132] transition-colors shadow-sm"
                  }
                />
              )}
              {!loggedIn && (
                <Button
                  onClick={() => {
                    trackFreeTrialClick();
                    freeTrialSubsdata(router);
                  }}
                  text={"Start Free Trial"}
                  customClass={
                    "text-base font-medium bg-[#002E25] text-white px-5 py-2 rounded-md hover:bg-[#004132] transition-colors shadow-sm"
                  }
                />
              )}
            </div>
          ) : null}
          
          <button onClick={menuHandler} className="lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              {menuOpen ? (
                <>
                  {/* X icon when menu is open */}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </>
              ) : (
                <>
                  {/* Hamburger icon when menu is closed */}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </>
              )}
            </svg>
          </button>
        </div>
        
        {/* Mobile menu */}
        <Transition
          show={menuOpen}
          enter="transition-opacity duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity "
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="bg-white fixed left-0 top-[76px] w-full h-[calc(100vh-76px)] flex flex-col z-50 border-t border-gray-100 pb-safe overflow-y-auto">
            <div className="flex flex-col min-h-full">
              {/* Main navigation items */}
              <div className="px-6 py-8 flex-1">
                <Link href="/" passHref>
                  <div 
                    onClick={() => {
                      menuHandler();
                      trackMenuNavigation('Home (Mobile)', '/');
                    }}
                    className={`flex items-center py-4 ${router.asPath === "/" ? "text-[#049A55] font-medium" : "text-gray-800"} hover:bg-gray-50 rounded-md px-2`}
                  >
                    <div className="w-10 flex justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <span className="text-lg">Home</span>
                  </div>
                </Link>
                
                {/* SEO Tools Section */}
                <div className="mt-4 mb-2 px-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">
                  SEO Tools
                </div>
                
                {Links.find(item => item.text === "SEO Tools")?.sublinks.map((sublink, index) => (
                  <Link key={index} href={sublink.link} passHref>
                    <div 
                      onClick={() => {
                        menuHandler();
                        trackMenuNavigation(`SEO Tools - ${sublink.text} (Mobile)`, sublink.link);
                      }}
                      className={`flex items-center py-4 ${isActive(sublink.link) ? "text-[#049A55] font-medium" : "text-gray-800"} hover:bg-gray-50 rounded-md px-2`}
                    >
                      <div className="w-10 flex justify-center mr-4">
                        {sublink.icon}
                      </div>
                      <span className="text-lg">{sublink.text}</span>
                    </div>
                  </Link>
                ))}
                
                {/* Free Tools Section */}
                <div className="mt-6 mb-2 px-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">
                  Free Tools
                </div>
                
                {Links.find(item => item.text === "Free Tools")?.sublinks.map((sublink, index) => (
                  <Link key={index} href={sublink.link} passHref>
                    <div 
                      onClick={() => {
                        menuHandler();
                        trackMenuNavigation(`Free Tools - ${sublink.text} (Mobile)`, sublink.link);
                      }}
                      className={`flex items-center py-4 ${isActive(sublink.link) ? "text-[#049A55] font-medium" : "text-gray-800"} hover:bg-gray-50 rounded-md px-2`}
                    >
                      <div className="w-10 flex justify-center mr-4">
                        {sublink.icon}
                      </div>
                      <span className="text-lg">{sublink.text}</span>
                    </div>
                  </Link>
                ))}
                
                {/* Pricing Link */}
                <div className="mt-6 mb-2 px-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">
                  Other
                </div>
                
                <Link href="/pricing" passHref>
                  <div 
                    onClick={() => {
                      menuHandler();
                      trackMenuNavigation('Pricing (Mobile)', '/pricing');
                    }}
                    className={`flex items-center py-4 ${router.asPath === "/pricing" ? "text-[#049A55] font-medium" : "text-gray-800"} hover:bg-gray-50 rounded-md px-2`}
                  >
                    <div className="w-10 flex justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {/* Credit card icon for pricing/payment */}
                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                        <line x1="1" y1="10" x2="23" y2="10"></line>
                      </svg>
                    </div>
                    <span className="text-lg">Pricing</span>
                  </div>
                </Link>
              </div>
              
              {/* Bottom action buttons - now in a separate non-scrolling container */}
              <div className="border-t border-gray-200 p-6 pb-16 md:pb-6 flex flex-col gap-4 mt-auto">
                {loggedIn ? (
                  <Button
                    onClick={() => {
                      router.push("/dashboard");
                      menuHandler();
                      trackMenuNavigation('Dashboard Button (Mobile)', '/dashboard');
                    }}
                    text={"Go to Dashboard"}
                    customClass="w-full py-2.5 bg-[#002E25] text-white rounded-md font-medium text-base hover:bg-[#004132] transition-colors shadow-sm"
                  />
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        router.push("/sign-in");
                        menuHandler();
                        trackLoginClick();
                      }}
                      text={"Log in"}
                      customClass="w-full py-2.5 text-gray-700 hover:text-[#049A55] hover:bg-gray-100 rounded-md font-medium text-base transition-colors"
                    />
                    <Button
                      onClick={() => {
                        trackFreeTrialClick();
                        freeTrialSubsdata(router);
                        menuHandler();
                      }}
                      text={"Start Free Trial"}
                      customClass="w-full py-2.5 bg-[#002E25] text-white rounded-md font-medium text-base hover:bg-[#004132] transition-colors shadow-sm"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </>
  );
};

export default Header;
